<style scoped>
.nomination-card {
  width: 210mm;
  min-height: 297mm;
  margin: auto;
  padding: 20mm;
  background: #fff;
  direction: rtl;
  color: #000;
  font-family: "Times New Roman", serif;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

.header-left h3 {
  margin-top: 25px;
  font-size: 22px;
  font-weight: bold;
}

.logo {
  width: 95px;
}

.title {
  margin-top: 15px;
  text-align: center;
  font-size: 24px;
  font-weight: bold;
  text-decoration: underline;
}

.year {
  font-weight: bold;
}

.intro {
  margin-top: 25px;
  text-align: center;
  line-height: 2;
  font-size: 21px;
}

.student-row {
  display: flex;
  justify-content: space-between;
  gap: 60px;
  margin-bottom: 25px;
}

.student-item {
  flex: 1;
  display: flex;
  align-items: baseline;
  min-width: 0;
}

.label {
  font-weight: bold;
  font-size: 22px;
  white-space: nowrap;
  margin-left: 8px;
}

.value {
  color: #003399;
  font-size: 22px;
  white-space: nowrap; /* يمنع النزول لسطر جديد */
  margin-right: 6px;
}

.requirements {
  margin-top: 40px;
  direction: rtl;
  text-align: right;
  font-family: "Times New Roman", serif;
}

.section-title {
  font-size: 24px;
  font-weight: bold;
  text-decoration: underline;
  margin-bottom: 18px;
}

.section-intro {
  font-size: 20px;
  line-height: 2;
  margin-bottom: 20px;
}

.sub-title {
  font-size: 22px;
  font-weight: bold;
  margin-top: 25px;
  margin-bottom: 12px;
}

.req-list {
  list-style: none;
  padding-right: 30px;
  margin: 0;
}

.req-list li {
  font-size: 20px;
  line-height: 2;
  position: relative;
}

.req-list li::before {
  content: "-";
  position: absolute;
  right: -18px;
}

.bullet-list {
  padding-right: 45px;
  margin-top: 8px;
}

.bullet-list li {
  font-size: 20px;
  line-height: 2;
}

.payment-section {
  margin-top: 35px;
  direction: rtl;
  text-align: right;
  padding-right: 30px;
}

.section-title {
  font-size: 24px;
  font-weight: bold;
  text-decoration: underline;
  margin-bottom: 20px;
}

.payment-intro {
  font-size: 20px;
  margin-bottom: 15px;
}

.payment-text {
  font-size: 22px;
  font-weight: bold;
}

.qr-wrapper {
  margin-top: 20px;
  text-align: center;
}

.qr-image {
  width: 150px;
  height: 150px;
}

.page-divider {
  margin: 45px 0;
}

.payment-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

.payment-header .logo {
  width: 95px;
}

.header-title {
  font-size: 22px;
  font-weight: bold;
  color: #777;
  margin-top: 25px;
}

.myu-link {
  text-align: center;
  margin: 25px 0;
  font-size: 22px;
}

.myu-link a {
  color: #0056c7;
  font-weight: bold;
  text-decoration: underline;
}

.payment-body {
  direction: rtl;
  text-align: right;
}

.payment-body h3 {
  font-size: 22px;
  font-weight: bold;
  text-decoration: underline;
  margin-top: 20px;
  margin-bottom: 10px;
}

.payment-body ul {
  margin: 0;
  padding-right: 30px;
}

.payment-body li {
  font-size: 20px;
  line-height: 2;
}

.circle-list {
  list-style-type: disc;
  padding-right: 55px !important;
}

.payment-list {
  margin-top: 15px;
  padding-right: 30px;
}

.payment-list li {
  font-size: 20px;
  line-height: 2;
  margin-bottom: 8px;
}

.support-section {
  margin-top: 35px;
  direction: rtl;
  text-align: right;
  padding-right: 30px;
}

.support-text {
  font-size: 20px;
  margin: 8px 0;
}

.contact-row {
  margin-top: 25px;
  display: flex;
  justify-content: center;
  gap: 150px;
}

.contact-item {
  text-align: center;
}

.contact-label {
  font-size: 21px;
  font-weight: bold;
  text-decoration: underline;
  margin-bottom: 10px;
}

.contact-link {
  color: #0056c7;
  font-size: 22px;
  font-weight: bold;
  text-decoration: underline;
}

.contact-phone {
  font-size: 22px;
  color: #000;
}

</style>

<template>
  <div class="nomination-card">

    <!-- Header -->
    <div class="header">

      <div class="header-left">
        <h3>{{ serverTranslate($store.state.title) }}</h3>
      </div>

      <div class="header-right">
        <img
            :src="universityLogo"
            class="logo"
        />
      </div>

    </div>

    <!-- Title -->
    <div class="title">

      بطاقة ترشيح مبدئي للعام الجامعي

      <span class="year">
        {{ nomination.academicYearName }} - {{ nomination.academicSemesterName }}
      </span>

    </div>

    <!-- Introduction -->
    <div class="intro">

      يسر {{ serverTranslate($store.state.title) }} أن تتقدم إليكم بخالص التهنئة
      بمناسبة ترشيحكم المبدئي للالتحاق بالجامعة،
      وترحب بانضمامكم إلى أسرتها الأكاديمية
      كأحد أبناء المستقبل،
      متمنية لكم مسيرة جامعية حافلة بالتميز والنجاح.

    </div>

    <!-- Student Data -->
    <div class="student-info">

      <!-- Row 1 -->
      <div class="student-row">

        <div class="student-item">
          <span class="label">اسم الطالب :</span>
          <span class="value">{{ nomination.studentName }}</span>
        </div>

        <div class="student-item">
          <span class="label">الرقم القومي :</span>
          <span class="value">{{ nomination.nationalID }}</span>
        </div>

      </div>

      <!-- Row 2 -->
      <div class="student-row">

        <div class="student-item">
          <span class="label">نوع الشهادة :</span>
          <span class="value">{{ nomination.certificateType }}</span>
        </div>

        <div class="student-item">
          <span class="label">المجموع (المعتمد) :</span>
          <span class="value">{{ nomination.total }}</span>
        </div>

      </div>

      <!-- Row 3 -->
      <div class="student-row">

        <div class="student-item">
          <span class="label">سنة الحصول على الثانوية :</span>
          <span class="value">{{ nomination.qualificationYear }}</span>
        </div>

        <div class="student-item">
          <span class="label">الكلية المرشح لها الطالب :</span>
          <span class="value">{{ nomination.appFacultyName }}</span>
        </div>

      </div>

    </div>

    <!-- ================= Admission Requirements ================= -->

    <div class="requirements">

      <h2 class="section-title">
        متطلبات استكمال إجراءات القيد :
      </h2>

      <p class="section-intro">
        يرجى استيفاء المستندات التالية حتى تتمكن الجامعة من إنهاء إجراءات قيدكم بالجامعة
        للعام الجامعي
        {{ nomination.academicYearName }}
        /
        {{ nomination.academicSemesterName }}
        وهي كالتالي:
      </p>

      <!-- First -->
      <h3 class="sub-title">
        أولاً: متطلبات إثبات المؤهل الدراسي:
      </h3>

      <ul class="req-list">

        <li>
          <label style="text-decoration: underline"> طلاب الثانوية العامة المصرية </label>
          (أصل شهادة الثانوية العامة + صورة)
        </li>

        <li>
          <label style="text-decoration: underline"> طلاب الشهادة الأزهرية </label>
          (أصل شهادة الثانوية الأزهرية + صورة)
        </li>

        <li>
          <label style="text-decoration: underline"> طلاب الشهادات العربية المعادلة </label>
          (أصل الشهادة الدراسية كاملة معتمدة وموثقة من الخارجية المصرية)
        </li>

        <li>
          <label style="text-decoration: underline">طلاب الشهادات الأجنبية والدولية</label>

        </li>

      </ul>

      <ul class="bullet-list">

        <li>
          أصل الشهادة الدراسية كاملة معتمدة وموثقة من الخارجية المصرية.
        </li>

        <li>
          أصل التسلسل الدراسي المعتمد بما يثبت استكمال 12 صف دراسي.
        </li>

        <li>
          أصل شهادة اللغة العربية والتربية الدينية.
        </li>

        <li>
          مستند اعتماد المدرسة (قائمة المدارس) للمدارس المصرية.
        </li>

        <li>
          خطاب اعتماد
          <strong>AMIDEAST</strong>
          أو الجهة المعتمدة المناظرة للمدارس خارج جمهورية مصر العربية.
        </li>

      </ul>

      <!-- Second -->
      <h3 class="sub-title">
        ثانياً: متطلبات إثبات الشخصية:
      </h3>

      <ul class="req-list">

        <li>
          أصل شهادة ميلاد كمبيوتر حديثة (بالرقم الثلاثي للطلاب الذكور) + صورة.
        </li>

        <li>
          عدد 2 صورة بطاقة الرقم القومي للطالب + صورة بطاقة ولي الأمر.
        </li>

        <li>
          عدد (6) صور شخصية حديثة مقاس (4 × 6).
        </li>

        <li>
          حافظة بلاستيك كبسولة.
        </li>

      </ul>

      <!-- Third -->
      <h3 class="sub-title">
        ثالثاً: متطلبات الموقف التجنيدي (للطلاب الذكور)
      </h3>

      <ul class="req-list">

        <li>
          نموذج 2 جند.
        </li>

        <li>
          بطاقة عسكرية 6 جند أو (7 جند مختومة من مكتب التجنيد بالقسم التابع له الطالب).
        </li>

      </ul>

    </div>

    <!-- ================= Electronic Payment ================= -->

    <div class="payment-section">

      <h2 class="section-title">
        متطلبات استكمال إجراءات السداد الإلكتروني:
      </h2>

      <p class="payment-intro">
        لسداد الرسوم الدراسية المقررة يرجى اتباع الخطوات التالية:
      </p>

      <p class="payment-text">
        قم بمسح رمز الاستجابة السريع
        <strong>(QR Code)</strong>
        للدخول إلى النظام الإلكتروني للطالب
        <strong>(MyU)</strong>
      </p>

      <div class="qr-wrapper">
        <img
            :src="myuQr"
            alt="MyU QR Code"
            class="qr-image"
        />
      </div>

    </div>


    <hr class="page-divider">


    <div class="payment-details">

      <div class="payment-header">

        <div class="header-title">
          {{ serverTranslate($store.state.title) }}
        </div>

        <img
            :src="universityLogo"
            class="logo"
        >

      </div>

      <div class="myu-link">

        أو من خلال الرابط :

        <br>

        <a
            :href="nomination.myuURL"
            target="_blank"
        >
          https://myu.mansnu.edu.eg/
        </a>

      </div>

      <div class="payment-body">

        <h3>خطوات السداد :</h3>

        <ul>

          <li>
            يتم تسجيل الدخول على النظام الإلكتروني للطالب
            <strong>MyU</strong>
            (اسم المستخدم والرقم السري هو الرقم القومي للطالب لحين تسجيل الدخول لأول مرة ثم يقوم الطالب بتغيير الرقم
            السري).
          </li>

          <li>
            يتم الدخول على الرسوم ومنها إلى إذن الدفع ويقوم بسداد الرسوم إلكترونياً.
          </li>

        </ul>

        <h3>تنبيهات هامة :</h3>

        <ul>

          <li>
            تم إصدار هذا الترشيح استناداً إلى البيانات المدخلة من قبل الطالب عبر نظام التقديم الإلكتروني.
          </li>

          <li>
            يعد هذا الترشيح ترشيحاً مبدئياً ولا يعتبر قبولاً نهائياً إلا بعد:
          </li>

        </ul>

        <ul class="circle-list">

          <li>مراجعة أصول المستندات.</li>

          <li>التحقق من صحة البيانات المقدمة.</li>

          <li>استيفاء شروط القبول المعتمدة.</li>

          <li>سداد الرسوم الدراسية المقررة.</li>

        </ul>

        <!-- ================= More Important Notes ================= -->

        <ul class="payment-list">

          <li>
            يخضع قبول الطلاب الحاصلين على الشهادات العربية والأجنبية والدولية
            لقواعد المجلس الأعلى للجامعات ووزارة التعليم العالي والبحث العلمي
            المنظمة لمعادلة الشهادات.
          </li>

          <li>
            تحتفظ الجامعة بحق إلغاء الترشيح أو القيد في حال ثبوت عدم صحة أي بيانات
            أو مستندات مقدمة.
          </li>

          <li>
            يرجى استكمال إجراءات القيد وسداد الرسوم الدراسية وتسليم المستندات
            المطلوبة خلال
            <strong>48 ساعة</strong>
            من تاريخ إرسال البطاقة،
            وإلا يعتبر الترشيح
            <strong>ملغياً</strong>
            إذا لم تقرر الجامعة خلاف ذلك.
          </li>

          <li>
            يتحمل الطالب مسؤولية متابعة الإشعارات والتعليمات الصادرة من الجامعة
            عبر المنصات الرسمية.
          </li>

        </ul>


        <!-- ================= Contact ================= -->

        <div class="support-section">

          <h2 class="section-title">
            الدعم والتواصل:
          </h2>

          <p class="support-text">
            للاستفسارات والدعم الفني وخدمات القبول والتسجيل.
          </p>

          <p class="support-text">
            يرجى التواصل على:
          </p>

          <div class="contact-row">

            <div class="contact-item">

              <div class="contact-label">
                الإيميل التالي:
              </div>

              <a
                  :href="'mailto:' + nomination.email"
                  class="contact-link"
              >
                asa@mansnu.edu.eg
              </a>

            </div>

            <div class="contact-item">

              <div class="contact-label">
                <lable>الخط الساخن :</lable>
                <br/>
                201067705333+
              </div>

              <div class="contact-phone">
                {{ nomination.hotline }}
              </div>

            </div>

          </div>

        </div>

      </div>

    </div>


  </div>


</template>


<script>
import serverTranslationsMixin from "@/mixins/serverTranslations.js";
import myuQr from "@/assets/images/myu-qr.png";
// import store from "@/store";

export default {
  name: "NominationCard",

  mixins: [serverTranslationsMixin],

  data() {
    return {
      loading: false,
      myuQr,
      nomination: {
        applicationID: "",

        academicYearName: "",
        academicSemesterName: "",

        studentName: "",
        nationalID: "",

        certificateType: "",
        total: "",
        qualificationYear: "",

        appFacultyName: "",

        myuURL: "",

        email: "",
        hotline: "",

        qualificationDocuments: [],
        identityDocuments: [],
        militaryDocuments: [],

        paymentSteps: [],

        notes: []
      }
    };
  },

  computed: {

    universityLogo() {
      return this.$store.getters.getUniversityLogo;
    },


    applicationID() {


      return this.$route.params.appID || "";

      // if (this.$route.params.id)
      //   return this.$route.params.id;
      //
      // if (this.$route.query.id)
      //   return this.$route.query.id;
      //
      // return "";
    }

  },

  mounted() {
    this.getNominationCard();
  },

  methods: {
    getNominationCard() {
      this.loading = true;
      this.$http.get(
          `/api/applications/get_nomination_card/${this.applicationID}/`,
      ).then(response => {
            this.loading = false;
            const d = response.data.data;
            this.nomination.applicationID = d.applicationID;
            this.nomination.academicYearName = d.academicYearName;
            this.nomination.academicSemesterName = d.academicSemesterName;
            this.nomination.studentName = this.serverTranslate(d.studentName)
            this.nomination.nationalID = d.nationalID;
            this.nomination.certificateType = d.qualificationType + "-" + d.qualificationDivision;
            this.nomination.total = d.total;
            this.nomination.qualificationYear = d.qualificationYear;
            this.nomination.appFacultyName = d.appFacultyName;
            this.nomination.myuURL = d.myuURL;
            this.nomination.email = d.email;
            this.nomination.hotline = d.hotline;
            this.nomination.qualificationDocuments =
                d.qualificationDocuments || [];
            this.nomination.identityDocuments =
                d.identityDocuments || [];
            this.nomination.militaryDocuments =
                d.militaryDocuments || [];
            this.nomination.paymentSteps =
                d.paymentSteps || [];
            this.nomination.notes =
                d.notes || [];
            this.$nextTick(() => {
              setTimeout(() => {
                window.print();
              }, 500);
            });
          },
      ).catch(err => {

        this.loading = false;
        this.$toasted.show(
            this.serverTranslate(
                err.response &&
                err.response.data &&
                err.response.data.message
                    ? err.response.data.message
                    : this.$t("ERROR")
            ),
            {
              type: "error",
              icon: "error_outline",
              duration: 3000,
              theme: "bubble",
              position: "bottom-left"
            }
        );

      });

    },


    printPage() {

      window.print();

    },


    refresh() {

      this.getNominationCard();

    }

  }

};
</script>